<template>
  <div>
    <v-row class="px-4">
      <v-col cols="12">
        <h3 class="pa-0">#NEW_Gruppe @Instagram</h3>
      </v-col>
    </v-row>
    <v-row class="px-4 pa-0">
      <v-col cols="12" class="pa-0">
        <v-card flat class="d-flex">
          <v-container fluid class="py-0">
            <v-row>
              <v-col
                v-for="(item, index) in instaImages"
                :key="index"
                class="d-flex child-flex pa-1"
                cols="6"
              >
                <v-card :href="getFallbackUrl(item)" target="_blank" flat tile class="d-flex">
                    <v-img :src="item.image" aspect-ratio="1" class="grey lighten-2">
                      <template v-slot:placeholder>
                        <v-row class="fill-height" align="center" justify="center">
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col cols="12" class="pa-1">
        <v-btn
          :href="instagramURL"
          target="_blank"
          block
          tile
          depressed
          color="accent"
        >
          Zeig mir mehr!
          <v-icon class="btn-instagram-icon">mdi-instagram</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { firebase } from "../../main";
export default {
  data() {
    return {
      isLoading: true,
      instaImages: null,
    };
  },
  computed: {
    showURL() {

    },
    instagramURL() {
      if(this.$store.state.inapp.isApp) {
        return "instagram://user?username=new_gruppe&fallbackurl=https%3A%2F%2Fwww.instagram.com%2Fnew_gruppe%2F";
      }
      return "https://www.instagram.com/new_gruppe/";
    }
  },
  methods: {
    getFallbackUrl(instaImage) {
      const shortcode = instaImage.shortcode;
      if(this.$store.state.inapp.isApp && typeof UserData !== "undefined" && UserData != null && typeof UserData.getMobileOS === "function") {
        const fallbackUrl = encodeURIComponent(`https://www.instagram.com/p/${shortcode}/`);
        const media_id = instaImage.media_id;
        if(UserData.getMobileOS() === "IOS") {
          // IOS requires media id
          return `instagram://media?id=${media_id}&fallbackurl=${fallbackUrl}`;
        }else{
          // Android requires shortcode
          return `instagram://media?id=${shortcode}&fallbackurl=${fallbackUrl}`;
        }
      }else{
        // Non-App users
        return `https://www.instagram.com/p/${shortcode}/`;
      }
    }
  },
  mounted() {
    firebase
      .firestore()
      .collection("instagram")
      .orderBy("timestamp", "desc")
      .limit(4)
      .onSnapshot((docs) => {
        this.instaImages = [];
        docs.forEach((doc) => {
          this.$set(this.instaImages, this.instaImages.length, doc.data());
        });
        this.isLoading = false;
      });
  },
};
</script>
<style lang="scss" scoped>
.instagram-holder {
  position: relative;
  width: 100%;
  padding-top: 100%;
  .holder {
    position: absolute;
    width: 50%;
    padding: 3px;
  }
  .holder-1 {
    left: 0;
    top: 0;
    height: 60%;
  }
  .holder-2 {
    left: 0;
    bottom: 0;
    height: 40%;
  }
  .holder-3 {
    right: 0;
    top: 0;
    height: 50%;
  }
  .holder-4 {
    right: 0;
    top: 50%;
    height: 30%;
  }
  .holder-5 {
    right: 0;
    bottom: 0;
    height: 20%;
    width: 25%;
  }
  .holder-6 {
    right: 25%;
    bottom: 0;
    height: 20%;
    width: 25%;
  }
}

.instagram-pos-link {
  padding: 0;
}

.btn-instagram-icon {
  position: absolute;
  left: 0;
}
</style>
